class Asset {
  // 获取assets静态资源
  static getAssetsFile = (url: string) => {
    return new URL(`../assets/${url}`, import.meta.url).href;
  };
}

export default Asset;
